import { Link } from 'react-router-dom';
import { Button, Dropdown } from 'react-bootstrap';
import {
  EXHIBITOR_USER_FAILED,
  AUTH_VISITOR_USER_FAILED,
  B2B_USER_FAILED,
} from '../../Helpers/Constant';
import { VisitorAuthContext } from '../../Context/AuthContex/VisitorAuthContext';
import { B2BAuthContext } from '../../Context/AuthContex/B2BAuthContext';
import { useExhibitorAuthContext } from '../../Context/AuthContex/ExhibitorAuthContext';
import { useQueryClient } from '@tanstack/react-query';
import CustomHeader from './CustomHeader';
const Header = () => {
  const queryClient = useQueryClient();
  const {
    state: { exhibitorUser },
    dispatch: authDispatch,
  } = useExhibitorAuthContext();

  const { visitorUser, dispatch: VisitorAuthDispatch } = VisitorAuthContext();
  const {
    state: { b2bUser },
    dispatch: B2BAuthDispatch,
  } = B2BAuthContext();

  const handleLogoutExhibitor = () => {
    authDispatch?.({
      type: EXHIBITOR_USER_FAILED,
    });
    queryClient.clear();
  };
  const handleLogout = () => {
    VisitorAuthDispatch?.({
      type: AUTH_VISITOR_USER_FAILED,
    });
    queryClient.clear();
  };

  const handleLogoutB2B = () => {
    B2BAuthDispatch?.({
      type: B2B_USER_FAILED,
    });

    queryClient.clear();
  };

  const renderLoginButtons = () => {
    if (exhibitorUser?.token) {
      return (
        <div style={{ display: 'flex', columnGap: 5 }}>
          <Link to={'/profile'} className='text-white text-decoration-none'>
            <Button className='btn btn-3 btn-info me-2'>Profile</Button>
          </Link>
          <Button
            onClick={handleLogoutExhibitor}
            className='btn btn-3 btn-primary'
          >
            Logout
          </Button>
        </div>
      );
    } else if (visitorUser?.token) {
      return (
        <div style={{ display: 'flex', columnGap: 5 }}>
          <Link
            to='/visitor/profile'
            className='text-white text-decoration-none'
          >
            <Button className='btn btn-3 btn-info me-2 w-100'>Profile</Button>
          </Link>
          <Button onClick={handleLogout} className='btn btn-3 btn-primary'>
            Logout
          </Button>
        </div>
      );
    } else if (b2bUser?.token) {
      return (
        <div style={{ display: 'flex', columnGap: 5 }}>
          <Link to='/b2b/profile' className='text-white text-decoration-none'>
            <Button className='btn btn-3 btn-info me-2 w-100'>Profile</Button>
          </Link>
          <Button onClick={handleLogoutB2B} className='btn btn-3 btn-primary'>
            Logout
          </Button>
        </div>
      );
    } else {
      return (
        <>
          <div className='header-btn'>
            <Dropdown className='pe-3'>
              <Dropdown.Toggle
                className='btn btn-3 btn-primary'
                id='dropdown-basic'
              >
                Registration
              </Dropdown.Toggle>
              <Dropdown.Menu align='start' className='ps-1'>
                <div className='pb-2 custom-hover'>
                  <Link
                    to='/book-your-space'
                    className='text-decoration-none text-black'
                  >
                    Exhibitor Registration
                  </Link>
                </div>
                <div className='custom-hover'>
                  <Link
                    to='/b2b-registration'
                    className='text-decoration-none text-black'
                  >
                    Buyer/Seller B2B Meeting Registration{' '}
                  </Link>
                </div>
                <div className='custom-hover'>
                  <Link
                    to='/visitor-registration'
                    className='text-decoration-none text-black'
                  >
                    Visitor Registration
                  </Link>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className='header-btn st-2 mt-2 mt-md-0'>
            <Dropdown className='pe-3'>
              <Dropdown.Toggle className='btn-info' id='dropdown-basic'>
                Login
              </Dropdown.Toggle>
              <Dropdown.Menu align='start' className='ps-1'>
                <div className='pb-2 custom-hover'>
                  <Link to='/login' className='text-decoration-none text-black'>
                    Exhibitor Login
                  </Link>
                </div>

                <div
                  style={{ marginRight: '15px' }}
                  className='pb-2 custom-hover'
                >
                  <Link
                    to='/b2b-login'
                    className='text-decoration-none text-black'
                  >
                    Buyer/Seller B2B Meeting Login
                  </Link>
                </div>
                <div
                  style={{ marginRight: '15px' }}
                  className='pb-2 custom-hover'
                >
                  <Link
                    to='/visitor-login'
                    className='text-decoration-none text-black'
                  >
                    Visitor Login
                  </Link>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      );
    }
  };

  return (
    <>
      <CustomHeader />
      {/* <Navbar
        collapseOnSelect
        expand='md'
        variant='dark'
        style={{
          backgroundColor: '#fff',
          borderBottom: '1px solid #fc097c',
          marginTop: 200,
        }}
        sticky='top'
      >
        <Container fluid className='custom-container'>
          <a href='/'>
            <img
              src='/assets/bttf-logo.png'
              alt=''
              width={70}
              height={70}
              style={{ objectFit: 'contain' }}
            />
          </a>

          <Navbar.Toggle aria-controls='responsive-navbar-nav' />
          <Navbar.Collapse id='responsive-navbar-nav'>
            <Nav className='ms-auto'>
              <div className='header-navigation mt-4'>
                <ul className='main-menu'>
                  <li className='active-menu'>
                    <a href='/'>Home</a>
                  </li>
                  <li>
                    <Link to='#'>
                      About
                      <MdKeyboardArrowDown size={20} />
                    </Link>
                    <ul className='sub-menu'>
                      <li>
                        <Link to='#'>About BTTF</Link>
                      </li>
                      <li>
                        <Link to='#'>About TOAB</Link>
                      </li>
                      <li>
                        <Link to='#'>Exhibition</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to='#'>
                      Event
                      <MdKeyboardArrowDown size={20} />
                    </Link>
                    <ul className='sub-menu'>
                      <li>
                        <Link to='/event-list'>Event List</Link>
                      </li>
                      <li>
                        <Link to='#'>Event Matrix</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to='#'>
                      Galleries
                      <MdKeyboardArrowDown size={20} />
                    </Link>
                    <ul className='sub-menu'>
                      <li>
                        <Link to='#'>Photo Gallery</Link>
                      </li>
                      <li>
                        <Link to='#'>Video Gallery</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to='#'>
                      Media Room
                      <MdKeyboardArrowDown size={20} />
                    </Link>
                    <ul className='sub-menu'>
                      <li>
                        <Link to='#'>Print Media News</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to='/all-exhibitor'>Exhibitors</Link>
                  </li>
                  <li>
                    <Link to={'/product-services'} rel='noopener noreferrer'>
                      Product & Service
                    </Link>
                  </li>
                  <li className='change-color'>
                    <Link to='#'>BTTF {currentYear}</Link>
                  </li>
                  <li>
                    <Link to='/book-your-space'>Book Your Space</Link>
                  </li>
                </ul>
              </div>
            </Nav>

            <Nav className='ms-auto'>{renderLoginButtons()}</Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar> */}
    </>
  );
};

export default Header;
